import { useRef } from "react";

export function useScrollRestore<T extends HTMLElement>() {
  const ref = useRef<T>(null);

  const restoreScroll = () => {
    if (ref.current) {
      window.scroll({
        top: ref.current.offsetTop,
        behavior: "smooth",
      });
    }
  };

  return { scrollRef: ref, restoreScroll };
}
